import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import type { LocationJobsResponse } from '@recruitee/locations-types';
import { ID } from '@recruitee/ngrx';

@Injectable({ providedIn: 'root' })
export class LocationsJobsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(id: ID): Observable<LocationJobsResponse> {
    return this.httpApi.get(`/locations/${id}/offers`);
  }
}
